<template>
  <div class="infos-gerais">
    <v-card>
      <v-card-title class="primary">
        <h3 style="font-size: 18px; color: #FFF; font-weight: 500">
          Histórico de Sinistro
        </h3>
      </v-card-title>
      <v-card-text>
        <div class="frequencia" v-if="listagemFrequencia.length > 0" >
            <p class="mt-2">Frequência da Sinistralidade</p>
            <div class="wrapper-blocks">
                <div v-for="item in listagemFrequencia"  class="block-frequencia">
                    <div class="borda">
                        <p class="periodo-text">Periodo: {{ item.periodo }}</p>
                        <p class="mb-0">Total de Sinistros: {{ item.totalSinistros }}</p>
                        <p>Frequência: {{ item.frequencia }} </p>
                    </div>
                </div>
            </div>
            <v-divider class="mt-3"></v-divider>
        </div>

        <p class="mt-4">Listagem de apólices</p>
        <v-layout row align-center class="filtro-ano mb-3">
          <span class="filtro-ano-conector mr-3">De</span>
          <div class="filtro-ano-field-wrapper">
            <span
              class="filtro-ano-label"
              :class="{ 'filtro-ano-label--visivel': filtroAnoDeFocado || !!filtroAnoDeInput }"
            >Preencha o Ano</span>
            <v-text-field
              v-model="filtroAnoDeInput"
              placeholder="1980"
              type="number"
              hide-details
              single-line
              @focus="filtroAnoDeFocado = true"
              @blur="filtroAnoDeFocado = false"
              @keyup.enter="aplicarFiltroAno"
            ></v-text-field>
          </div>
          <span class="filtro-ano-conector mx-3">até</span>
          <div class="filtro-ano-field-wrapper">
            <span
              class="filtro-ano-label"
              :class="{ 'filtro-ano-label--visivel': filtroAnoAteFocado || !!filtroAnoAteInput }"
            >Preencha o Ano</span>
            <v-text-field
              v-model="filtroAnoAteInput"
              placeholder="2026"
              type="number"
              hide-details
              single-line
              @focus="filtroAnoAteFocado = true"
              @blur="filtroAnoAteFocado = false"
              @keyup.enter="aplicarFiltroAno"
            ></v-text-field>
          </div>
          <v-btn
            color="primary"
            class="ml-3 filtro-ano-btn"
            @click="aplicarFiltroAno"
          >
            <v-icon>search</v-icon>
          </v-btn>
        </v-layout>
        <v-data-table
          :items="historicosFiltrados"
          :rows-per-page-items="[10]"
          item-key="item"
          class="elevation-1 table-grid"
          :headers="headerHistoricoSinistro"
        >
          <template v-slot:no-data>
            <p class="no-data-apolice">
              Nenhum resultado encontrado.
            </p>
          </template>
          <template v-slot:items="props">
            <td class="themeGrey--text ">
              {{ props.item.nomeSegurado }}
            </td>
            <td class="themeGrey--text">
              {{ props.item.seguradora }}
            </td>
            <td class="themeGrey--text">
              {{ props.item.numeroApolice }}
            </td>
            <td class="themeGrey--text">
              {{ props.item.inicioDeVigencia }}
            </td>
            <td class="themeGrey--text">
              {{ props.item.fimDeVigencia }}
            </td>
            <td class="themeGrey--text">
              {{ props.item.totalDeSinistro }}
            </td>
            <td class="themeGrey--text">
              {{ props.item.totalDeTerceirosEnvolvidos }}
            </td>
            <td class="themeGrey--text">
              {{ props.item.totalDeSinistrosIndenizados }}
            </td>
            <td class="themeGrey--text">
              <v-btn
                @click="abrirDetalhes(props.item.detalhes)"
                flat
                color="secondary"
              >
                VER DETALHES
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          flat
          color="secondary"
          @click="$emit('fecharModalHistoricoSinistro')"
        >
          Voltar
        </v-btn>
      </v-card-actions>
    </v-card>
    <template>
      <v-dialog persintant width="85%" height="800" v-model="detalhesAtivo">
        <v-card clas="data-table-custom" v-show="detalhesAtivo">
          <v-card-title class="primary">
            <h3 style="font-size: 18px; color: #FFF; font-weight: 500">
              Histórico de Sinistro
            </h3>
          </v-card-title>
          <v-card-text>
            <p class="mt-2">Listagem de sinistros</p>
            <v-data-table
              :items="listagemDetalhes"
              :rows-per-page-items="[10]"
              item-key="item"
              class="elevation-1 table-grid"
              :headers="headersDetalhesSinistro"
            >
              <template v-slot:no-data>
                <p class="no-data-apolice">
                  Nenhum resultado encontrado.
                </p>
              </template>
              <template v-slot:items="props">
                <td class="themeGrey--text">
                  {{ props.item.dadoSinistro }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.tipo }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.tipoRamo }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.natureza }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.status }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.tipoIndenizacao }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.tipoEncerramento }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.codigoSinistro }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.placa }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.chassi }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.marcaModelo }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.anoModelo }}
                </td>
                <td class="themeGrey--text">
                  {{ props.item.codFipe }}
                </td>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-btn flat color="secondary" @click="fecharDetalhes">
              Voltar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "ModalHistoricoSinistro",
  props: {
    listagemHistoricoSinistro: {
      type: Array,
      required: true
    },
    listagemFrequencia: Array
  },
  data: () => ({
    detalhesAtivo: false,
    listagemDetalhes: [],
    filtroAnoDeInput: "",
    filtroAnoAteInput: "",
    filtroAnoDe: null,
    filtroAnoAte: null,
    filtroAnoDeFocado: false,
    filtroAnoAteFocado: false,
    headerHistoricoSinistro: [
      { text: "Nome do segurado", value: "nomeSegurado", sortable: false },
      { text: "Seguradora", value: "seguradora", sortable: false },
      { text: "N. Apólice", value: "nmrApolice", sortable: false },
      { text: "Inicio de vigência", value: "inicioVigencia", sortable: false },
      { text: "Fim de vigência", value: "fimVigencia", sortable: false },
      { text: "Total sinistros", value: "totalSinistro", sortable: false },
      {
        text: "Terceiros envolvidos",
        value: "terceiroEnvolvido",
        sortable: false
      },
      {
        text: "Sinistro indenizado",
        value: "sinistroIndenizado",
        sortable: false
      },
      {
        text: "Listagem de sinistros",
        value: "sinistroIndenizado",
        sortable: false
      }
    ],
    headersDetalhesSinistro: [
      { text: "Dado sinistro", value: "dadoSinistro", sortable: false },
      { text: "Tipo", value: "tipo", sortable: false },
      { text: "Tipo Ramo", value: "tipoRamo", sortable: false },
      { text: "Natureza", value: "natureza", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Tipo Indenização", value: "tipoIndenizacao", sortable: false },
      { text: "Tipo Encerramento", value: "tipoEncerramento", sortable: false },
      { text: "Código Sinistro", value: "codigoSinistro", sortable: false },
      { text: "Placa", value: "placa", sortable: false },
      { text: "Chassi", value: "chassi", sortable: false },
      { text: "Marca / Modelo", value: "marcaModelo", sortable: false },
      { text: "Ano Modelo", value: "anoModelo", sortable: false },
      { text: "Cód. Fipe", value: "codFipe", sortable: false }
    ]
  }),
  computed: {
    historicosFiltrados() {
      const de = this.filtroAnoDe;
      const ate = this.filtroAnoAte;
      if (de === null && ate === null) {
        return this.listagemHistoricoSinistro;
      }
      return this.listagemHistoricoSinistro.filter(item => {
        if (!item.inicioDeVigencia) return false;
        const partes = item.inicioDeVigencia.split("/");
        const ano = parseInt(partes[2], 10);
        if (isNaN(ano)) return false;
        if (de !== null && ano < de) return false;
        if (ate !== null && ano > ate) return false;
        return true;
      });
    }
  },
  methods: {
    abrirDetalhes(detalhes) {
      this.detalhesAtivo = true;
      this.listagemDetalhes = detalhes;
    },
    fecharDetalhes() {
      this.detalhesAtivo = false;
      this.listagemDetalhes = [];
    },
    aplicarFiltroAno() {
      const de = parseInt(this.filtroAnoDeInput, 10);
      const ate = parseInt(this.filtroAnoAteInput, 10);
      this.filtroAnoDe = isNaN(de) ? null : de;
      this.filtroAnoAte = isNaN(ate) ? null : ate;
    }
  }
};
</script>
<style>
.no-data-apolice {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 0;
  text-align: center;
}
.themeGrey--text {
  text-align: center;
}

.infos-gerais .v-datatable thead {
  background-color: white !important;
}

.data-table-custom .v-datatable thead {
  background-color: white !important;
}
.infos-gerais .table-grid .column {
  color: black !important;
}
.wrapper-blocks {
  max-height: 400px;
  overflow-y: auto;
  display: flex;
  flex-direction: row;
}
.borda {
  border-right: 1px solid #ccc;
}
.block-frequencia {
  padding: 20px;
  display: inline-block;
  width: 200px;
  flex: none;
}
.block-frequencia p {
    color: #878787;
  }
.periodo-text {
    font-weight: bold;
}
.filtro-ano {
  flex: 0 1 auto;
}
.filtro-ano-conector {
  font-size: 16px;
  color: #878787;
}
.filtro-ano-field-wrapper {
  display: flex;
  flex-direction: column;
  max-width: 110px;
  flex: 0 0 110px;
}
.filtro-ano-field-wrapper .v-text-field {
  margin-top: 0;
  padding-top: 0;
}
.filtro-ano-label {
  font-size: 11px;
  color: #1976d2;
  line-height: 1;
  margin-bottom: 2px;
  min-height: 13px;
  visibility: hidden;
  transition: visibility 0s, opacity 0.15s ease;
  opacity: 0;
}
.filtro-ano-label--visivel {
  visibility: visible;
  opacity: 1;
}
.filtro-ano-btn {
  min-width: 36px;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalHistorioSinistro.vue